import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { theme } from '@startengine/design-system.theme.main';
import { useQueryClient } from '@tanstack/react-query';
import TermsAccordionRow from './TermsAccordionRow';
import TermsStats from './TermStats';

const Terms = () => {
  const queryClient = useQueryClient();

  // Get offering data from cache with improved error handling
  const offeringData = queryClient.getQueryData(['offeringData']);

  // const getOfferingType = () => {
  //   if (offeringData?.offeringType === 'convertible_note') {
  //     return 'Convertible Note';
  //   }

  //   if (offeringData?.offeringType === 'equity') {
  //     return 'Equity';
  //   }

  //   if (offeringData?.offeringType === 'revenue_share') {
  //     return 'Revenue Share';
  //   }

  //   if (offeringData?.offeringType === 'safe') {
  //     return 'Simple Agreement for Future Equity';
  //   }

  //   return 'Other';
  // };

  // Early return if no offering data to prevent rendering empty terms
  if (!offeringData) {
    return null;
  }

  return (
    <Grid container data-cy="terms-section">
      <TermsStats />
      <Grid container item xs={12} mt={7.5}>
        <Grid item xs={12}>
          <TermsAccordionRow offeringData={offeringData} />
        </Grid>
        <Grid
          item
          container
          sx={{
            mt: 2,
          }}
          xs={12}
        >
          {!!offeringData?.offeringTermsDescription && (
            <Grid item xs={12}>
              <Typography variant="p3Italicize">
                {offeringData?.offeringTermsDescription}
              </Typography>
            </Grid>
          )}
          {!!offeringData?.perksAndOtherMaterialInformation && (
            <Grid item xs={12}>
              <Box
                sx={{
                  ...theme?.typography?.p3,
                }}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: offeringData?.perksAndOtherMaterialInformation,
                  }}
                />
              </Box>
            </Grid>
          )}
        </Grid>
        {!!offeringData?.irregularUseOfProceeds && (
          <Grid
            item
            container
            sx={{
              mt: 1,
            }}
            xs={12}
          >
            <Grid item xs={12}>
              <Typography variant="p3Italicize">Irregular Use of Proceeds</Typography>
              <Box
                sx={{
                  ...theme?.typography?.p3Italicize,
                }}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: offeringData?.irregularUseOfProceeds,
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default Terms;
